export const ORDER_TITLE = 'Order';
export const CUSTOMER_TITLE = 'Customer';
export const PHOTO_TITLE = 'Photos';
